import {CommonModule} from "@angular/common";
import {Component, Input, NgModule} from '@angular/core';
import {FormsModule} from "@angular/forms";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {NgSelectModule} from "@ng-select/ng-select";

@Component({
  selector: 'lib-svg',
  template: '<div style="stroke: none;" [innerHTML]="safeSvg" [style.width]="size" [style.height]="size"></div>',
  styleUrls: ['./svg.component.scss']
})
export class SvgComponent {
  @Input() set svg(value: string) {
    this.safeSvg = this.sanitizer.bypassSecurityTrustHtml(value);
  }

  @Input() size: string | undefined = undefined;

  safeSvg: SafeHtml | null = null;

  constructor(private sanitizer: DomSanitizer) {}
}


@NgModule({
  declarations: [SvgComponent],
  imports: [CommonModule, FormsModule, NgSelectModule],
  exports: [SvgComponent]
})
export class SvgModule {}